<template>
  <div class="content-step__button-list col-big-vspace">
    <button
      class="content-step__button-list__image-item"
      :class="active.name === typo.name ? 'active' : ''"
      :key="index"
      @click="changeTypo(typo)" v-for="(typo, index) in typos"
    >
      <div
        class="svg svg--mini"
        :class="{color, 'svg--active' : active.name === typo.name}"
        v-html="typo.svg"
      ></div>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    typos: {
      type: Array,
      default: () => [],
    },
    active: {
      type: Object,
      default: () => {},
    },
    color: {
      type: String,
      default: '',
    }
  },
  methods: {
    changeTypo(typo) {
      this.$emit('change-typo', typo);
    },
  },
};
</script>
